module.exports = __webpack_public_path__ + "img/eye.fc8eb7ed.svg";